<template>
    <div class="layout-inline-menu" :class="{'layout-inline-menu-active': active}">
        <a class="layout-inline-menu-action flex flex-row align-items-center" :class="menuMode === 'horizontal' ? 'p-3 lg:p-1 py-3' : 'p-3'" :style="{'min-width': menuMode === 'horizontal' ? '165px' : 0} ">
            <span class="flex flex-column mr-2">
                <span class="font-bold">{{ this.$store.getters['infoNavigation/NameCustomer'] }}</span>
            </span>
        </a>
        
        <transition :name="menuMode === 'horizontal' && !isMobile() ? 'layout-inline-menu-action-panel-horizontal' : 'layout-inline-menu-action-panel'">
            <ul v-show="active" :class="['layout-inline-menu-action-panel', { 'layout-inline-menu-action-panel-horizontal' : menuMode === 'horizontal' && !isMobile()}]">
            <li class="layout-inline-menu-action-item">
                    <a class="flex flex-row align-items-center" @click="openPanelConfig">
                        <i class="pi pi-cog pi-fw"></i>
                        <span>Configuraciones</span>
                    </a>
                </li>
        </ul>
        </transition>
    </div>

</template>

<script>
import EventBus from './event-bus';
import EventosEntregas from './views/EmpresaTransporte/configuraciones/eventos.vue'
import InspeccionVehicular from './views/EmpresaTransporte/configuraciones/InspeccionVehicular.vue'
	export default {
        name: "AppInlineMenu",
        props: {
            active: {
                type: Boolean,
                default: false
            },
            menuMode: String,
            inlineMenuKey: String
        },
        data() {
			return {
                modal_panel: false,
                activeIndex: 0,
                NameCustomer: this.$store.getters['infoNavigation/NameCustomer'],
                activeIndexSeway: 0,
                tabClicked: false,
                modalAmplio: '1100px',
                modalResponsive: '90vw',
                overlayMenuItems: [
				{
					label: 'Configuraciones', icon: 'pi pi-fw pi-cog',
					items: [
						{
							label: 'Seway-APP', icon: 'pi pi-fw pi-shield',
							items: [
								{label: 'EVENTOS-ENTREGAS', icon: 'pi pi-fw pi-history', to: this.$store.getters['infoNavigation/Rol']+'/configuracion-eventos'},
								// {label: 'Configuración 2', icon: 'pi pi-fw pi-history', to: this.$store.getters['infoNavigation/Rol']+'/ventas'}
							]
						},
						{
							label: 'Systram', icon: 'pi pi-fw pi-shield',
							items: [
								// {label: 'EVENTOS-ENTREGAS', icon: 'pi pi-fw pi-history', to: this.$store.getters['infoNavigation/Rol']+'/configuracion'},
								// {label: 'Configuración 2', icon: 'pi pi-fw pi-history', to: this.$store.getters['infoNavigation/Rol']+'/ventas'}
							]
						},
					]
				}
				],
            }
        },
		methods: {
			onClick(event) {
                this.$emit('change-inlinemenu', !this.active, this.inlineMenuKey);
				event.preventDefault();
			},
            handleTabChange(event) {
                // if (!this.tabClicked) {
                    console.log('Cambiaste de TabPanel. Nuevo índice activo:', event.index);

                    switch (event.index) {
                        case 0:
                            console.log('aaa');
                            
                            break;
                        case 1:
                            console.log('bbb');
                            EventBus.emit('traer-inspeccion');
                            // EventBus.emit('show-container',response.data.rol);
                            break;
                        default:
                            break;
                    }
                    // this.tabClicked = true; // Establece la variable de estado en verdadero para evitar futuras ejecuciones
                // }
            },
            toggleMenu(event) {
				this.$refs.menu.toggle(event);
			},
            isMobile() {
                return window.innerWidth <= 991;
            },
            openPanelConfig(){
                this.modal_panel = true;
            }
		},
        created(){  
            this.NameCustomer = this.$store.getters['infoNavigation/NameCustomer'];
            // this.tabClicked = false;
        },
        computed: {
            menuSize() {
                // Verifica el tamaño del dispositivo
                if (window.innerWidth >= this.$primevue.config.breakpoints.md) {
                    // Para dispositivos lg y más grandes
                    return this.modalAmplio;
                } else {
                    // Para dispositivos más pequeños que lg
                    return this.modalResponsive;
                }
            },
            isRTL() {
				return this.$appState.RTL;
			}
        },
        components: {
            'EventosEntregas': EventosEntregas,
            'InspeccionVehicular': InspeccionVehicular,
        }
	}
</script>

<style scoped>
.p-tabview-vertical .p-tabview-nav {
  flex-direction: column;
}

.p-tabview-vertical .p-tabview-nav li {
  margin: 0;
}

.p-tabview-vertical .p-tabview-nav li a {
  text-align: left;
}

.p-tabview-vertical .p-tabview-nav li.p-highlight {
  background-color: #f4f4f4;
}
</style>
